import n, { useRef as r, useEffect as e } from "react";
import o from "prop-types";
import a from "@leafygreen-ui/box";
import { css as t, cx as i } from "@leafygreen-ui/emotion";
import { fontFamilies as l, spacing as d } from "@leafygreen-ui/tokens";
import { registerRipple as p } from "@leafygreen-ui/ripple";
import { useUsingKeyboardContext as c } from "@leafygreen-ui/leafygreen-provider";
import { transparentize as g } from "polished";
import { uiColors as s } from "@leafygreen-ui/palette";
import { jsx as x } from "@emotion/react";
function u(n, r) {
  var e = Object.keys(n);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(n);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(n, r).enumerable;
    })), e.push.apply(e, o);
  }
  return e;
}
function b(n) {
  for (var r = 1; r < arguments.length; r++) {
    var e = null != arguments[r] ? arguments[r] : {};
    r % 2 ? u(Object(e), !0).forEach(function (r) {
      f(n, r, e[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(n, Object.getOwnPropertyDescriptors(e)) : u(Object(e)).forEach(function (r) {
      Object.defineProperty(n, r, Object.getOwnPropertyDescriptor(e, r));
    });
  }
  return n;
}
function f(n, r, e) {
  return r in n ? Object.defineProperty(n, r, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : n[r] = e, n;
}
function h() {
  return (h = Object.assign || function (n) {
    for (var r = 1; r < arguments.length; r++) {
      var e = arguments[r];
      for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && (n[o] = e[o]);
    }
    return n;
  }).apply(this, arguments);
}
function y(n, r) {
  if (null == n) return {};
  var e,
    o,
    a = function (n, r) {
      if (null == n) return {};
      var e,
        o,
        a = {},
        t = Object.keys(n);
      for (o = 0; o < t.length; o++) e = t[o], r.indexOf(e) >= 0 || (a[e] = n[e]);
      return a;
    }(n, r);
  if (Object.getOwnPropertySymbols) {
    var t = Object.getOwnPropertySymbols(n);
    for (o = 0; o < t.length; o++) e = t[o], r.indexOf(e) >= 0 || Object.prototype.propertyIsEnumerable.call(n, e) && (a[e] = n[e]);
  }
  return a;
}
function m(n, r) {
  return r || (r = n.slice(0)), Object.freeze(Object.defineProperties(n, {
    raw: {
      value: Object.freeze(r)
    }
  }));
}
var k,
  w,
  v,
  O,
  D,
  P,
  j,
  z,
  S,
  N,
  F,
  M,
  G,
  B,
  L,
  E,
  I,
  X,
  C,
  A,
  K,
  R,
  T,
  Y,
  q,
  H,
  J,
  Q,
  U,
  V,
  W,
  Z,
  $,
  _,
  nn,
  rn,
  en,
  on,
  an,
  tn,
  ln,
  dn = {
    Primary: "primary",
    PrimaryOutline: "primaryOutline",
    Default: "default",
    Danger: "danger",
    DangerOutline: "dangerOutline"
  },
  pn = {
    XSmall: "xsmall",
    Small: "small",
    Default: "default",
    Large: "large"
  },
  cn = "light",
  gn = "dark",
  sn = t(k || (k = m(["\n  // unset browser default\n  appearance: none;\n  padding: 0;\n  margin: 0;\n  background-color: transparent;\n  border: 0px solid transparent;\n  display: inline-flex;\n  align-items: stretch;\n  border-radius: 4px;\n  transition: all 150ms ease-in-out;\n  position: relative;\n  text-decoration: none;\n  cursor: pointer;\n  z-index: 0;\n\n  &:focus {\n    outline: none;\n  }\n\n  &:disabled {\n    pointer-events: none;\n  }\n\n  &:active,\n  &:focus,\n  &:hover {\n    text-decoration: none;\n  }\n"]))),
  xn = (f(B = {}, cn, (f(j = {}, dn.Primary, t(w || (w = m(["\n      background-color: ", ";\n      box-shadow: 0px 2px 3px rgba(19, 170, 82, 0.4);\n      color: ", ";\n\n      &:focus {\n        color: ", ";\n      }\n\n      &:hover,\n      &:active {\n        color: ", ";\n        background-color: ", ";\n        box-shadow: 0px 2px 3px rgba(19, 170, 82, 0.4), 0px 0px 0px 3px #c3e7ca;\n      }\n    "])), s.green.dark1, s.white, s.white, s.white, s.green.dark2)), f(j, dn.PrimaryOutline, t(v || (v = m(["\n      border: 1px solid ", ";\n      color: ", ";\n\n      &:focus {\n        color: ", ";\n      }\n\n      &:hover,\n      &:active {\n        color: ", ";\n        background-color: rgba(9, 128, 76, 0.04); // green dark 1\n        border: 1px solid ", ";\n        box-shadow: 0px 0px 0px 3px ", ";\n      }\n    "])), s.green.dark1, s.green.dark2, s.green.dark2, s.green.dark2, s.green.dark1, s.green.light2)), f(j, dn.Default, t(O || (O = m(["\n      background-color: ", ";\n      border: 1px solid ", ";\n      box-shadow: 0px 1px 2px rgba(6, 22, 33, 0.3);\n      color: ", ";\n\n      &:focus {\n        color: ", ";\n      }\n\n      &:hover,\n      &:active {\n        color: ", ";\n        background-color: ", ";\n        border: 1px solid ", ";\n        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.3),\n          0px 0px 0px 3px ", ";\n      }\n    "])), s.gray.light3, s.gray.base, s.gray.dark2, s.gray.dark2, s.gray.dark2, s.white, s.gray.dark1, s.gray.light2)), f(j, dn.Danger, t(D || (D = m(["\n      background-color: ", ";\n      box-shadow: 0px 1px 2px rgba(207, 74, 34, 0.4);\n      color: ", ";\n\n      &:focus {\n        color: ", ";\n      }\n\n      &:hover,\n      &:active {\n        color: ", ";\n        background-color: ", ";\n        box-shadow: 0px 4px 4px rgba(207, 74, 34, 0.25),\n          0px 0px 0px 3px ", ";\n      }\n    "])), s.red.base, s.white, s.white, s.white, s.red.dark1, s.red.light2)), f(j, dn.DangerOutline, t(P || (P = m(["\n      border: 1px solid ", ";\n      color: ", ";\n\n      &:focus {\n        color: ", ";\n      }\n\n      &:hover,\n      &:active {\n        color: ", ";\n        background: rgba(207, 74, 34, 0.04);\n        border: 1px solid ", ";\n        box-shadow: 0px 0px 0px 4px ", ";\n      }\n    "])), s.red.base, s.red.dark2, s.red.dark2, s.red.dark2, s.red.base, s.red.light2)), j)), f(B, gn, (f(G = {}, dn.Primary, t(z || (z = m(["\n      background-color: ", ";\n      border: 1px solid ", ";\n      color: ", ";\n\n      &:focus {\n        color: ", ";\n      }\n\n      &:hover,\n      &:active {\n        color: ", ";\n        background-color: ", ";\n        box-shadow: 0px 0px 0px 3px ", ";\n      }\n    "])), s.green.dark2, s.green.base, s.white, s.white, s.white, s.green.dark1, s.green.dark2)), f(G, dn.PrimaryOutline, t(S || (S = m(["\n      border: 1px solid ", ";\n      color: #0ad05b;\n\n      &:focus {\n        color: #0ad05b;\n      }\n\n      &:hover,\n      &:active {\n        color: #0ad05b;\n        background-color: rgba(10, 208, 91, 0.08);\n        border: 1px solid ", ";\n        box-shadow: 0px 0px 0px 3px ", ";\n      }\n    "])), s.green.base, s.green.base, s.green.dark2)), f(G, dn.Default, t(N || (N = m(["\n      background-color: ", ";\n      border: 1px solid ", ";\n      color: ", ";\n\n      &:focus {\n        color: ", ";\n      }\n\n      &:hover,\n      &:active {\n        color: ", ";\n        background-color: ", ";\n        border: 1px solid ", ";\n        box-shadow: 0px 0px 0px 3px ", ";\n      }\n    "])), s.gray.dark2, s.gray.base, s.white, s.white, s.white, s.gray.dark1, s.gray.base, s.gray.dark2)), f(G, dn.Danger, t(F || (F = m(["\n      background-color: ", ";\n      border: 1px solid #f97216;\n      color: ", ";\n\n      &:focus {\n        color: ", ";\n      }\n\n      &:hover,\n      &:active {\n        color: ", ";\n        background-color: ", ";\n        border: 1px solid #f97216;\n        box-shadow: 0px 0px 0px 3px ", ";\n      }\n    "])), s.red.dark1, s.white, s.white, s.white, s.red.base, s.red.dark2)), f(G, dn.DangerOutline, t(M || (M = m(["\n      border: 1px solid #f97216;\n      color: #f97216;\n\n      &:focus {\n        color: #f97216;\n      }\n\n      &:hover,\n      &:active {\n        color: #f97216;\n        background: rgba(249, 114, 22, 0.08);\n        box-shadow: 0px 0px 0px 3px ", ";\n      }\n    "])), s.red.dark2)), G)), B),
  un = (f(J = {}, cn, (f(A = {}, dn.Primary, t(L || (L = m(["\n      &:focus {\n        background-color: ", ";\n        box-shadow: 0px 4px 4px rgba(0, 124, 173, 0.4),\n          0px 0px 0px 3px ", ";\n      }\n    "])), s.green.dark2, s.focus)), f(A, dn.PrimaryOutline, t(E || (E = m(["\n      &:focus {\n        background-color: rgba(9, 128, 76, 0.04);\n        border: 1px solid ", ";\n        box-shadow: 0px 0px 0px 3px ", ";\n      }\n    "])), s.green.dark1, s.focus)), f(A, dn.Default, t(I || (I = m(["\n      &:focus {\n        background: ", ";\n        border: 1px solid ", ";\n        box-shadow: 0px 4px 4px rgba(0, 124, 173, 0.4),\n          0px 0px 0px 3px ", ";\n      }\n    "])), s.white, s.gray.dark1, s.focus)), f(A, dn.Danger, t(X || (X = m(["\n      &:focus {\n        background-color: ", ";\n        box-shadow: 0px 4px 4px rgba(0, 124, 173, 0.4),\n          0px 0px 0px 3px ", ";\n      }\n    "])), s.red.dark1, s.focus)), f(A, dn.DangerOutline, t(C || (C = m(["\n      &:focus {\n        background: rgba(207, 74, 34, 0.04);\n        border: 1px solid ", ";\n        box-shadow: 0px 0px 0px 3px #019ee2;\n      }\n    "])), s.red.dark2)), A)), f(J, gn, (f(H = {}, dn.Primary, t(K || (K = m(["\n      &:focus {\n        background: ", ";\n        box-shadow: 0px 4px 4px rgba(0, 124, 173, 0.4),\n          0px 0px 0px 3px ", ";\n      }\n    "])), s.green.dark1, s.focus)), f(H, dn.PrimaryOutline, t(R || (R = m(["\n      &:focus {\n        background: rgba(10, 208, 91, 0.08);\n        border: 1px solid ", ";\n        box-shadow: 0px 0px 0px 3px #139fd7;\n      }\n    "])), s.green.dark1)), f(H, dn.Default, t(T || (T = m(["\n      &:focus {\n        background-color: ", ";\n        box-shadow: 0px 0px 0px 3px #2f9fc5;\n      }\n    "])), s.gray.dark1)), f(H, dn.Danger, t(Y || (Y = m(["\n      &:focus {\n        background: ", ";\n        box-shadow: 0px 0px 0px 3px ", ";\n      }\n    "])), s.red.base, s.focus)), f(H, dn.DangerOutline, t(q || (q = m(["\n      &:focus {\n        background: rgba(249, 114, 22, 0.08);\n        border: 1px solid #f97216;\n        box-shadow: 0px 0px 0px 3px #019ee2;\n      }\n    "])))), H)), J),
  bn = (f(V = {}, cn, t(Q || (Q = m(["\n    background-color: ", ";\n    border: 1px solid ", ";\n    box-shadow: 0px 0px 0px 1px ", ";\n    cursor: not-allowed;\n    color: ", ";\n\n    &:hover {\n      background-color: ", ";\n      border: 1px solid ", ";\n      box-shadow: 0px 0px 0px 1px ", ";\n      cursor: not-allowed;\n      color: ", ";\n    }\n  "])), s.gray.light2, s.gray.light2, s.gray.light1, s.gray.dark1, s.gray.light2, s.gray.light2, s.gray.light1, s.gray.dark1)), f(V, gn, t(U || (U = m(["\n    background: rgba(61, 79, 88, 0.3);\n    border: 1px solid ", ";\n    color: ", ";\n    cursor: not-allowed;\n\n    &:hover {\n      background: rgba(61, 79, 88, 0.3);\n      border: 1px solid ", ";\n      color: ", ";\n      cursor: not-allowed;\n    }\n  "])), s.gray.dark2, s.gray.base, s.gray.dark2, s.gray.base)), V),
  fn = (f(nn = {}, pn.XSmall, t(W || (W = m(["\n    height: 22px;\n    text-transform: uppercase;\n    font-size: 12px;\n    line-height: 1em;\n    font-weight: bold;\n    letter-spacing: 0.4px;\n  "])))), f(nn, pn.Small, t(Z || (Z = m(["\n    height: 28px;\n  "])))), f(nn, pn.Default, t($ || ($ = m(["\n    height: 36px;\n  "])))), f(nn, pn.Large, t(_ || (_ = m(["\n    height: 48px;\n    font-size: 18px;\n    line-height: 24px;\n  "])))), nn),
  hn = (f(on = {}, 14, t(rn || (rn = m(["\n    font-size: 14px;\n  "])))), f(on, 16, t(en || (en = m(["\n    font-size: 16px;\n    // Pixel pushing for optical alignment purposes\n    transform: translateY(1px);\n  "])))), on);
var yn,
  mn,
  kn,
  wn,
  vn,
  On,
  Dn,
  Pn,
  jn,
  zn,
  Sn,
  Nn,
  Fn,
  Mn,
  Gn,
  Bn,
  Ln,
  En,
  In,
  Xn,
  Cn,
  An,
  Kn,
  Rn,
  Tn,
  Yn,
  qn,
  Hn,
  Jn,
  Qn,
  Un,
  Vn,
  Wn,
  Zn,
  $n = "#0AD05B",
  _n = "#09804C",
  nr = "#F97216",
  rr = (f(ln = {}, cn, (f(an = {}, dn.Primary, $n), f(an, dn.PrimaryOutline, g(.76, _n)), f(an, dn.Default, s.gray.light2), f(an, dn.Danger, nr), f(an, dn.DangerOutline, g(.76, s.red.base)), an)), f(ln, gn, (f(tn = {}, dn.Primary, $n), f(tn, dn.PrimaryOutline, g(.76, s.green.base)), f(tn, dn.Default, s.gray.base), f(tn, dn.Danger, nr), f(tn, dn.DangerOutline, g(.76, nr)), tn)), ln),
  er = (f(Fn = {}, cn, (f(On = {}, dn.Primary, t(yn || (yn = m(["\n      color: ", ";\n    "])), s.green.light3)), f(On, dn.PrimaryOutline, t(mn || (mn = m(["\n      color: ", ";\n    "])), s.green.dark1)), f(On, dn.Default, t(kn || (kn = m(["\n      color: ", ";\n    "])), s.gray.dark1)), f(On, dn.Danger, t(wn || (wn = m(["\n      color: ", ";\n    "])), s.red.light3)), f(On, dn.DangerOutline, t(vn || (vn = m(["\n      color: ", ";\n    "])), s.red.base)), On)), f(Fn, gn, (f(Nn = {}, dn.Primary, t(Dn || (Dn = m(["\n      color: ", ";\n    "])), s.green.light2)), f(Nn, dn.PrimaryOutline, t(Pn || (Pn = m(["\n      color: #13aa52;\n    "])))), f(Nn, dn.Default, t(jn || (jn = m(["\n      color: ", ";\n    "])), s.gray.light1)), f(Nn, dn.Danger, t(zn || (zn = m(["\n      color: ", ";\n    "])), s.red.light3)), f(Nn, dn.DangerOutline, t(Sn || (Sn = m(["\n      color: #f97216;\n    "])))), Nn)), Fn),
  or = (f(Yn = {}, cn, (f(In = {}, dn.Primary, t(Mn || (Mn = m(["\n      color: ", ";\n    "])), s.white)), f(In, dn.PrimaryOutline, t(Gn || (Gn = m(["\n      color: ", ";\n    "])), s.green.dark1)), f(In, dn.Default, t(Bn || (Bn = m(["\n      color: ", ";\n    "])), s.gray.dark2)), f(In, dn.Danger, t(Ln || (Ln = m(["\n      color: ", ";\n    "])), s.white)), f(In, dn.DangerOutline, t(En || (En = m(["\n      color: #cf4a22;\n    "])))), In)), f(Yn, gn, (f(Tn = {}, dn.Primary, t(Xn || (Xn = m(["\n      color: ", ";\n    "])), s.white)), f(Tn, dn.PrimaryOutline, t(Cn || (Cn = m(["\n      color: #0ad05b;\n    "])))), f(Tn, dn.Default, t(An || (An = m(["\n      color: ", ";\n    "])), s.white)), f(Tn, dn.Danger, t(Kn || (Kn = m(["\n      color: ", ";\n    "])), s.white)), f(Tn, dn.DangerOutline, t(Rn || (Rn = m(["\n      color: #f97216;\n    "])))), Tn)), Yn),
  ar = (f(Un = {}, pn.XSmall, t(qn || (qn = m(["\n    height: 14px;\n    width: 14px;\n  "])))), f(Un, pn.Small, t(Hn || (Hn = m(["\n    height: 16px;\n    width: 16px;\n  "])))), f(Un, pn.Default, t(Jn || (Jn = m(["\n    height: 16px;\n    width: 16px;\n  "])))), f(Un, pn.Large, t(Qn || (Qn = m(["\n    height: 20px;\n    width: 20px;\n  "])))), Un),
  tr = (f(Zn = {}, cn, t(Vn || (Vn = m(["\n    color: ", ";\n  "])), s.gray.light1)), f(Zn, gn, t(Wn || (Wn = m(["\n    color: ", ";\n  "])), s.gray.dark1)), Zn);
function ir(r) {
  var e = r.glyph,
    o = r.variant,
    a = r.size,
    t = r.darkMode,
    l = r.disabled,
    d = r.isIconOnlyButton,
    p = r.className,
    c = !d && {
      "aria-hidden": !0,
      role: "presentation"
    },
    g = t ? gn : cn,
    s = d ? or[g][o] : er[g][o];
  return n.cloneElement(e, b({
    className: i(s, f({}, tr[g], l), ar[a], p)
  }, c));
}
ir.displayName = "ButtonIcon";
var lr,
  dr,
  pr,
  cr,
  gr,
  sr,
  xr,
  ur,
  br,
  fr,
  hr,
  yr,
  mr,
  kr = ["variant", "size", "darkMode", "baseFontSize", "disabled", "leftGlyph", "rightGlyph", "children", "className"],
  wr = t(lr || (lr = m(["\n  overflow: hidden;\n  border-radius: 3px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n"]))),
  vr = t(dr || (dr = m(["\n  display: flex;\n  align-items: center;\n  height: 100%;\n  width: 100%;\n  pointer-events: none;\n  position: relative;\n  z-index: 0;\n  font-family: ", ";\n"])), l.default),
  Or = (f(xr = {}, pn.XSmall, t(pr || (pr = m(["\n    padding-left: 6px;\n    padding-right: 6px;\n  "])))), f(xr, pn.Small, t(cr || (cr = m(["\n    padding-left: 12px;\n    padding-right: 12px;\n  "])))), f(xr, pn.Default, t(gr || (gr = m(["\n    padding-left: 12px;\n    padding-right: 12px;\n  "])))), f(xr, pn.Large, t(sr || (sr = m(["\n    padding-left: ", "px;\n    padding-right: ", "px;\n  "])), d[3], d[3])), xr),
  Dr = n.forwardRef(function (o, l) {
    var d,
      g,
      s = o.variant,
      u = void 0 === s ? dn.Default : s,
      k = o.size,
      w = void 0 === k ? pn.Default : k,
      v = o.darkMode,
      O = void 0 !== v && v,
      D = o.baseFontSize,
      P = void 0 === D ? 14 : D,
      j = o.disabled,
      z = void 0 !== j && j,
      S = o.leftGlyph,
      N = o.rightGlyph,
      F = o.children,
      M = o.className,
      G = y(o, kr),
      B = c().usingKeyboard,
      L = r(null);
    e(function () {
      var n,
        r = rr[O ? gn : cn][u];
      return null != L.current && (n = p(L.current, {
        backgroundColor: r
      })), n;
    }, [L, u, O]);
    var E,
      I = null !== (d = (S || N) && !F) && void 0 !== d && d,
      X = function (n) {
        var r = n.variant,
          e = n.size,
          o = n.darkMode,
          a = n.baseFontSize,
          t = n.disabled,
          l = n.showFocus,
          d = o ? gn : cn,
          p = xn[d][r],
          c = un[d][r],
          g = fn[e],
          s = hn[a];
        return i(sn, p, f({}, c, l), f({}, bn[d], t), s, g);
      }({
        variant: u,
        size: w,
        darkMode: O,
        baseFontSize: P,
        disabled: z,
        showFocus: B
      }),
      C = "string" == typeof G.href;
    (G.as && "button" === G.as || !C && !G.as) && (E = "button");
    var A = b(b({
        type: E,
        className: i(X, M),
        ref: l,
        as: function (n, r) {
          return n && !r ? "a" : "button";
        }(C, z)
      }, "string" != typeof G.href && {
        disabled: z
      }), {}, {
        "aria-disabled": z
      }, G),
      K = {
        variant: u,
        size: w,
        darkMode: O,
        disabled: z,
        isIconOnlyButton: I
      },
      R = w === pn.Large ? "8px" : "6px",
      T = x(n.Fragment, null, x("div", {
        className: wr,
        ref: L
      }), x("div", {
        className: i(vr, (g = {}, f(g, t(ur || (ur = m(["\n              justify-content: space-between;\n            "]))), !!N), f(g, t(br || (br = m(["\n              justify-content: center;\n            "]))), !N), g), Or[w])
      }, S && x(ir, h({
        glyph: S,
        className: i(f({}, t(fr || (fr = m(["margin-right: ", ";}"])), R), !I), t(hr || (hr = m(["\n                vertical-align: text-top;\n              "]))))
      }, K)), F, N && x("span", {
        className: t(yr || (yr = m(["\n              display: flex;\n              align-items: center;\n              justify-content: center;\n              margin-left: auto;\n            "])))
      }, x(ir, h({
        glyph: N,
        className: I ? "" : t(mr || (mr = m(["margin-left: ", ";}"])), R)
      }, K)))));
    return x(a, A, T);
  });
Dr.displayName = "Button", Dr.propTypes = {
  variant: o.oneOf(Object.values(dn)),
  darkMode: o.bool,
  baseFontSize: o.oneOf([14, 16]),
  size: o.oneOf(Object.values(pn)),
  disabled: o.bool,
  leftGlyph: o.element,
  rightGlyph: o.element,
  href: o.string
};
export default Dr;
export { pn as Size, dn as Variant };